module.exports = require("debug");


//////////////////
// WEBPACK FOOTER
// external "debug"
// module id = 3
// module chunks = 0